import type { ColorPaletteType } from "../models";

export const defaultColorPalette: ColorPaletteType = {
  fontDark: "#101727",
  fontLight: "#f0f0f0",
  // Generic tokens
  brand: "#9FA9EA",
  accent: "#F3503A",
  muted: "#64748B",
  // MUI-like defaults
  success: "#2E7D32",
  info: "#0288D1",
  warning: "#ED6C02",
  error: "#D32F2F",
  neutral: "#64748B",
};
